import { useState, useEffect } from "react"

const SubmissionStatusModal = ({
    visible = false,
    continueHandler = () => { },
    submissionStatus = {},
    allMessages = {},
}) => {
    const [isSubmitting, setIsSubmitting] = useState(true)

    useEffect(() => {
        const submitting = Object.values(submissionStatus ?? [])?.filter(status => status === "submitting")?.length > 0
        setIsSubmitting(submitting)
    }, [submissionStatus])

    return visible ? (
        <div className="absolute top-0 left-0 z-10 h-full w-full bg-[#0001] before:absolute before:top-0 before:left-0 before:h-full before:w-full before:backdrop-blur-md">
            <div className="absolute top-1/2 left-1/2 w-5/6 -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white px-6 py-8 lg:w-2/5">
                <p className="text-[28px] font-[500] text-[#000] capitalize mb-4">submission status</p>
                <ol className="flex flex-col">
                    {
                        Object.keys(submissionStatus ?? [])
                            ?.map(questionId => {
                                const ticketNo = Object.keys(allMessages ?? [])?.findIndex(id => id === questionId)
                                return (
                                    <li key={questionId} className="flex items-center justify-between px-2 border-b-solid border-b-[1px] border-b-[#ECEDEE] py-3">
                                        <p className="text-[14px] text-[#000] capitalize font-[400]">Ticket {ticketNo + 1}</p>
                                        {
                                            submissionStatus[questionId] === "submitting"
                                                ? <div className="submission-loader flex items-center justify-start">
                                                    <div className="typing__dot" />
                                                    <div className="typing__dot" />
                                                    <div className="typing__dot" />
                                                </div>
                                                : <p className="text-[14px] text-[#000] uppercase tracking-[0.5px] font-[500]">
                                                    submitted
                                                </p>
                                        }
                                    </li>
                                )
                            })
                    }
                </ol>
                <div className="flex items-center justify-end mt-8">
                    <button
                        disabled={isSubmitting}
                        className={`capitalize text-[16px] font-[500] tracking-[0.2px] text-[#FF7A1A] ${isSubmitting ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
                        onClick={continueHandler}
                    >
                        continue
                    </button>
                </div>
            </div>
        </div>
    ) : (<></>)
}

export default SubmissionStatusModal